import '../sass/style.scss';

import '@babel/polyfill';

import { navigation } from '../js/navigation';
import { skipLinkFocusFix } from '../js/skip-link-focus-fix';

navigation();
skipLinkFocusFix();
